export type PlayerCustomization = {
	superchargeRatingsEnabled?: boolean;
	superchargeRatingsDevelopEnabled?: boolean;
	disableDeathRetirement?: boolean;
	intangibleRating?: { mode: "raw" | "relative" | "absolute"; value: number };
	forcedFuzz?: string;
	forcedFuzzApplyPotential?: boolean;
	realPlayerDeterminism?: number;
	forcedFuture?: Record<number, any>;
	tendencyOverrides?: Record<string, number> & { locked?: Record<string, boolean> };
	playoffOverrides?: Record<string, number>;
};
export const ratingCeiling = (p: PlayerCustomization) => p.superchargeRatingsEnabled ? 1000 : 100;
export const overrideMultiplier = (v?: number) => v === undefined || v === 0 ? 1 : v < 0 ? Math.max(0, 1 + v / 100) : v;
export const displayedRating = (raw: number, p: PlayerCustomization, type: "ovr" | "pot" = "ovr") => {
	if ((type === "ovr" || p.forcedFuzzApplyPotential) && p.forcedFuzz?.trim()) {
		const n = Number(p.forcedFuzz); if (Number.isFinite(n)) return Math.round(Math.max(0, Math.min(1000, /^[+-]/.test(p.forcedFuzz.trim()) ? raw + n : n)));
	}
	const m = p.intangibleRating; if (!m || m.mode === "raw") return raw;
	return Math.round(Math.max(0, Math.min(1000, m.mode === "absolute" ? m.value : raw + m.value)));
};
export const validatePlayerCustomization = (p: PlayerCustomization) => {
	if (p.superchargeRatingsDevelopEnabled && !p.superchargeRatingsEnabled) throw new Error("Enable supercharged ratings first");
	if (p.realPlayerDeterminism !== undefined && (p.realPlayerDeterminism < 0 || p.realPlayerDeterminism > 1)) throw new Error("Invalid real-player determinism");
	if (p.forcedFuture && Object.keys(p.forcedFuture).length > 100) throw new Error("Too many future ages");
};
